module.exports = __webpack_public_path__ + "img/title5.768f58f7.png";